import React from 'react';
import { motion } from 'framer-motion';
import { categories } from '../data/products';

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-wrap gap-3 justify-center mb-8"
    >
      {categories.map((category, index) => (
        <motion.button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
            selectedCategory === category.id
              ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
              : 'bg-white text-gray-600 hover:text-gray-900 shadow-md hover:shadow-lg border border-gray-200'
          }`}
          whileHover={{ scale: 1.05, y: -2 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.1 + 0.2 }}
        >
          {category.name}
          <span className={`ml-2 px-2 py-1 rounded-full text-xs ${
            selectedCategory === category.id
              ? 'bg-white/20'
              : 'bg-gray-100'
          }`}>
            {category.count}
          </span>
        </motion.button>
      ))}
    </motion.div>
  );
};

export default CategoryFilter;